import React from 'react';
import { useSSEStore } from '../store/sseStore';
import './styles/ConnectionStatus.css';

export const ConnectionStatus: React.FC = () => {
  const status = useSSEStore((state) => state.status);
  const error = useSSEStore((state) => state.error);
  const reconnectAttempts = useSSEStore((state) => state.reconnectAttempts);
  const tokenId = useSSEStore((state) => state.tokenId);

  // Don't show anything if no active connection attempt (not on an NFT page)
  if (!tokenId) {
    return null;
  }

  // Don't show anything if connected
  if (status === 'connected') {
    return null;
  }

  const getStatusConfig = () => {
    switch (status) {
      case 'connecting':
        return {
          text: 'Connecting...',
          color: 'info',
          icon: (
            <svg className="connection-status-spinner" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          ),
        };
      case 'reconnecting':
        return {
          text: `Reconnecting... (${reconnectAttempts}/10)`,
          color: 'warning',
          icon: (
            <svg className="connection-status-spinner" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          ),
        };
      case 'disconnected':
        return {
          text: error || 'Connection Lost',
          color: 'error',
          icon: (
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ),
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div className={`connection-status connection-status-${config.color}`} role="alert">
      <div className="connection-status-icon">{config.icon}</div>
      <span className="connection-status-text">{config.text}</span>
    </div>
  );
};
